import axios from 'axios'
import { Toast } from 'vant'
import { getToken, removeToken } from '@/utils/token'

// 导入Totast自定义图片
import error01 from '@/assets/system/404_1.gif'

// 创建axios实例
const service = axios.create({
  baseURL: '/api/v1', // 后端接口前缀，根据实际情况调整
  timeout: 10000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 自动携带token
    const token = getToken()
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  },
  error => {
    Toast.fail('请求发送失败')
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    if (error.response && error.response.status === 403) {
      removeToken()
      // TODO:这里转跳太快没有出现toast
      Toast.fail('登录已过期，请重新登录')
      window.location.href = '/login'
    } else {
      const msg = error.response?.data?.message || '光缆被挖断了 正加复中！'
      // 这里的图标可以换成图片地址，比如：https://img.yzcdn.cn/vant/like-o.png
      const icon = error.response?.status === 404 ? error01 : 'like-o'
      Toast({
        message: msg,
        icon
      })
    }
    return Promise.reject(error)
  }
)

export default service
